import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/no-multi-comp */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AssetsConsumer from '@sitebase/assets-context/es/AssetsConsumer';


import { getAllowedAttributes } from '../props-filters';
import propTypeClassName from '../propTypeClassName';

/**
 * Asset component requires AssetsProvider to be useful.
 * AssetsProvider provides 'resolver' function that is call be Asset component with 'name' parameter.
 * 'Resolver' function should map 'name' to React Component or Promise that resolves to React Component.
 * @see See [Assets section](#assets) for a detailed description.
 */

var Asset = function (_PureComponent) {
  _inherits(Asset, _PureComponent);

  function Asset() {
    _classCallCheck(this, Asset);

    return _possibleConstructorReturn(this, (Asset.__proto__ || _Object$getPrototypeOf(Asset)).apply(this, arguments));
  }

  _createClass(Asset, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          loaderNode = _props.loaderNode,
          errorNode = _props.errorNode,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['name', 'loaderNode', 'errorNode', 'className']);

      var props = _extends({}, getAllowedAttributes(restProps), { className: className });
      return React.createElement(
        AssetsConsumer,
        { name: name },
        function (error, asset) {
          if (error) return errorNode;
          return asset ? React.createElement(asset, props) : loaderNode;
        }
      );
    }
  }]);

  return Asset;
}(PureComponent);

Asset.propTypes = {
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName,
  /** Name will be passed to 'resolver' function provided by AssetsProvider */
  name: PropTypes.string.isRequired,
  /** LoaderNode will be displayed while asset is loading */
  loaderNode: PropTypes.node,
  /** ErrorNode will be displayed when loading of asset failed */
  errorNode: PropTypes.node
};
Asset.defaultProps = {
  loaderNode: null,
  errorNode: null
};
export default Asset;